<template>
  <input
    v-model="inputValue"
    :readonly="readonly"
    @blur="handleBlur"
    class="form-control"
    size="8"
  />
</template>

<script>
import { convertUintTo2PosStr } from '../util.js';

export default {
  name: 'TimeInput',

  props: {
    value: {
      type: String,
      required: true,
    },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      inputValue: this.value,
      normalizedValue: this.value,
    };
  },

  watch: {
    inputValue(newInputValue) {
      this.normalizedValue = getNormalizedTimeStr(newInputValue);
      this.$emit('input', this.normalizedValue);
    },
  },

  methods: {
    handleBlur() {
      this.inputValue = this.normalizedValue;
    },
  },
};

function getNormalizedTimeStr(timeStr) {
  let timeObj = parseTimeStr(timeStr);
  if(timeObj === null) {
    timeObj = {h: 0, min: 0, sec: 0};
  }

  const normalizedTimeStr = convertTimeObjToTimeStr(timeObj)
  return normalizedTimeStr;
}

function parseTimeStr(timeStr) {
  if(timeStr === null) {
    // invalid input
    return null;
  }

  let h = 0;
  let min = 0;
  let sec = 0;

  const parts = timeStr.split(':');

  if(parts.length > 0) {
    h = parseHours(parts[0]);
    if(h === null) {
      // invalid format
      return null;
    }
  }

  if(parts.length > 1) {
    min = parseMin(parts[1]);
    if(min === null) {
      // invalid format
      return null;
    }
  }

  if(parts.length > 2) {
    sec = parseSec(parts[2]);
    if(sec === null) {
      // invalid format
      return null;
    }
  }

  return {
    h,
    min,
    sec,
  };
}

function parseHours(hoursStr) {
  let s = hoursStr.trim();
  if(s.length === 0) {
    return 0;
  }

  s = s.substring(0, 2);
  
  const n = parseInt(s, 10);
  if(isNaN(n)) {
    // invalid format
    return null;
  }

  if(n < 0) {
    return null;
  }
  if(n >= 24) {
    return null;
  }

  return n
}

function parseMin(minStr) {
  let s = minStr.trim();
  if(s.length === 0) {
    return 0;
  }

  s = s.substring(0, 2);
  
  const n = parseInt(s, 10);
  if(isNaN(n)) {
    // invalid format
    return null;
  }

  if(n < 0) {
    return null;
  }
  if(n >= 60) {
    return null;
  }

  return n
}

function parseSec(secStr) {
  let s = secStr.trim();
  if(s.length === 0) {
    return 0;
  }

  s = s.substring(0, 2);
  
  const n = parseInt(s, 10);
  if(isNaN(n)) {
    // invalid format
    return null;
  }

  if(n < 0) {
    return null;
  }
  if(n >= 60) {
    return null;
  }

  return n
}

function convertTimeObjToTimeStr(timeObj) {
  if(timeObj === null) {
    return null;
  }

  const hStr   = convertUintTo2PosStr(timeObj.h);
  const minStr = convertUintTo2PosStr(timeObj.min);
  const secStr = convertUintTo2PosStr(timeObj.sec);
  return hStr + ':' + minStr + ':' + secStr;
}

</script>
